import Breadcrumb from './rtBreadcrumb.vue';
import BreadcrumbItem from './rtBreadcrumbItem.vue';
export { Breadcrumb, BreadcrumbItem };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/breadcrumb/index.js